'use client';

import { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { captureTrackingParams } from '@/lib/tracking';
import { LocaleProvider } from '@/context/locale-context';
import type { Locale } from '@/lib/locale';
import { FordonFranLank } from '@/components/FordonFranLank';

const AuthInitializer = dynamic(
  () => import('@/components/AuthInitializer').then((m) => ({ default: m.AuthInitializer })),
  { ssr: false }
);

const PublicWsConnector = dynamic(
  () => import('@/components/PublicWsConnector').then((m) => ({ default: m.PublicWsConnector })),
  { ssr: false }
);

const Toaster = dynamic(
  () => import('@/components/ui/sonner').then((m) => ({ default: m.Toaster })),
  { ssr: false }
);

export function Providers({ locale, children }: { locale: Locale; children: React.ReactNode }) {
  // Capture gclid and UTM params from URL on every page load
  useEffect(() => {
    captureTrackingParams();
  }, []);

  return (
    <LocaleProvider locale={locale}>
      <AuthInitializer />
      <PublicWsConnector />
      <FordonFranLank />
      {children}
      <Toaster position="top-right" />
    </LocaleProvider>
  );
}
